const IGNORE = {};

export function stateIsEqual(a, b) {
  if (!a && !b) {
    return true;
  } else if (!a || !b) {
    return false;
  } else {
    return (
      a.isShowingModal === b.isShowingModal
      && a.model === b.model
    );
  }
}

export function buildModel$({state$, getModalState}) {
  const model$ = state$
    .map(getModalState)
    .startWith(IGNORE)
    .distinctUntilChanged(stateIsEqual)
    .pairwise()
    .map(([prevState, nextState]) => {
      if (prevState === IGNORE || nextState.isShowingModal) {
        return nextState.model;
      } else {
        return prevState.model;
      }
    })
    .distinctUntilChanged();

  return {
    model$,
  };
}



// WEBPACK FOOTER //
// ./src/js/components/modals/FormModal/utils.js